import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { EventsApiService } from 'features/events';
import { AutoDiscountDTO } from 'features/events/components/event-details/show-hide-attributes/auto-discount/auto-discount-add-modal/types';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createAutoDiscount } = EventsApiService();

export const useCreateAutoDiscount = (id: any) => {
    const { message } = App.useApp();

    return useMutation(
        (payload: AutoDiscountDTO) => {
            return createAutoDiscount(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (id) {
                    message.success("Discount has been updated successfully!!");
                } else {
                    message.success("Discount has been created successfully!!");
                }
            },
        },
    );
};
